import {useContext, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import cx from 'classnames';
import {Container} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Container/Container';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {CardTemplate} from './CardTemplate';
import {CardEditorDesktop} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/Desktop/CardEditorDesktop';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {TextEditor} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/Mobile/TextEditor/TextEditor';
import {Instructions} from './Instructions/Instructions';
import {
  selectActiveCardEditor,
  selectTouched,
} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {ImageEditor} from './ImageEditor/ImageEditor';

import './EventCreateEditor.sass';

const editors = {
  '': Instructions,
  intro: Instructions,
  image: ImageEditor,
  text: CardEditorDesktop,
};

export const EventCreateEditor = ({children}) => {
  const {canvas} = useContext(EventCreateContext);
  const dispatch = useDispatch();
  const activeObject = canvas?.getActiveObject();

  const activeCardEditor = useSelector(selectActiveCardEditor);
  const ActiveEditor = editors[activeCardEditor];

  const isUyo = useSelector((state) => {
    const fabricObjects = state?.fabricDesign?.fabricArt?.objects;
    return fabricObjects && fabricObjects.some((obj) => obj.type === 'uYOImage');
  });

  const touched = useSelector(selectTouched);
  const showActiveEditor = isUyo || (!['', 'intro'].includes(activeCardEditor) && touched);

  // canvas is not reactive, so we need to check each render, so no dependencies on this effect
  useEffect(() => {
    if (activeObject && !touched) {
      dispatch({type: UPDATE_DESIGN_OPTIONS, payload: {touched: true}});
    }

    return () => {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {textAreaOpen: false},
      });
    };
  });

  return (
    <Container
      className={cx(
        'event-create-editor',
        `event-create-editor--${showActiveEditor ? 'card-design' : 'no-active-editor'}`
      )}
    >
      {children}
      <TextEditor />
      <CardTemplate showActiveEditor={showActiveEditor} />
      {showActiveEditor && <ActiveEditor />}
    </Container>
  );
};
